import { createAction } from '@reduxjs/toolkit';
import { ConfirmationDialog } from 'redux/schemas/app/confirmation-dialog';

export const openConfirmationDialog = createAction<ConfirmationDialog>('OPEN_CONFIRMATION_DIALOG');
export const closeConfirmationDialog = createAction('CLOSE_CONFIRMATION_DIALOG');
export const changeDisableButtonState = createAction('CHANGE_DISABLE_BUTTON_STATE');
